import { errorMsg } from '../../constants/messages';
import { fileFormatOptions } from '../Stores';

const FormPackageDocumentsFormData = [
  {
    title: 'Documents Details',
    name: 'name',
    label: 'Document Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Documents Name', enableSort: false, allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'fileFormats',
    label: 'File Format',
    fieldType: {
      name: 'multiSelect',
      options: fileFormatOptions,
    },
    placeholder: 'Click here to select an file format',
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'File Format',
      enableSort: false,
      allowAddRecordClick: false,
      columnType: 'fileFormats',
    },
    isTableHeader: true,
    isAccordian: true,
    readonly: false,
  },
  {
    name: 'maxFiles',
    label: 'Max Files',
    fieldType: {
      name: 'number',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Max Files' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'category',
    label: 'Age Group',
    fieldType: {
      name: 'radio',
      options: [
        { label: 'Both', value: 'Both' },
        { label: 'Adult', value: 'Adult' },
        { label: 'Minor', value: 'Minor' },
      ],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Age Group' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'description',
    label: 'Description',
    fieldType: {
      name: 'textEditor',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Description' },
    isTableHeader: false,
    isAccordian: true,
    default: '',
  },
  {
    name: 'image',
    label: 'Document Image',
    fieldType: {
      name: 'documitraFile',
      accept: 'image/png, image/jpeg, image/jpg',
      maxCount: '1',
      allowImageCropping: true,
    },
    placeholder: 'Click here to upload document reference image',
    required: false,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Document Image',
      enableSort: false,
      allowAddRecordClick: false,
      columnType: 'image',
    },
    isTableHeader: false,
    isAccordian: true,
    default: '',
  },
  {
    title: 'Remarks',
    name: 'remarkPresets',
    label: 'Remarks',
    fieldType: {
      name: 'multipleTextInput',
      fieldName: 'Remark',
      minCount: 0,
      maxCount: 50,
    },
    placeholder: 'Enter a remark option (shown as checkbox when reviewing uploads)',
    required: false,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Remarks',
      enableSort: false,
      allowAddRecordClick: false,
    },
    isTableHeader: false,
    isAccordian: true,
    default: [],
  },
];

export { FormPackageDocumentsFormData };
